<template>
  <div class="page-foot-box">
    <div class="page-foot">
      <div class="logo-box">
        <div class="logo">HARMONY</div>
        <div class="title">{{ $t('home.pageFootModule.title') }}</div>
      </div>
      <div class="foot-nav-box">
        <div class="nav-box">
          <p class="min-title">{{ $t('home.pageFootModule.solution') }}</p>
          <p class="nav-title" @click="handleToVcModel">{{ $t('home.pageFootModule.businessModel') }}</p>
        </div>
        <div class="nav-box">
          <p class="min-title">{{ $t('home.pageFootModule.settled') }}</p>
          <p class="nav-title" @click="handleToSettledPlatform">{{ $t('home.pageFootModule.entryGuide') }}</p>
        </div>
        <div class="nav-box">
          <p class="min-title">{{ $t('home.pageFootModule.about') }}</p>
          <p class="nav-title" @click="handleToSubmitUserInfo">{{ $t('home.pageFootModule.contact') }}</p>
          <p class="nav-title" @click="handleToAboutUs">{{ $t('home.pageFootModule.aboutUs') }}</p>
        </div>
      </div>
      <div class="contact-information-box">
        <div class="email">
          <p class="min-title">{{ $t('home.pageFootModule.email') }}</p>
          <p class="nav-title">liushanglin@harmonyseller.com</p>
        </div>
        <div class="wx">
          <p class="min-title">{{ $t('home.pageFootModule.wx') }}</p>
          <img src="https://mj-uploads.oss-cn-shenzhen.aliyuncs.com/uploads/foreStatic/quantora/assets/images/wx_qr.png"
            alt="">
        </div>
      </div>
    </div>
    <p class="record-number">HONG KONG HARMONY GLOBAL TRADE CO.，LIMITED</p>
  </div>
</template>

<script>
import { toAboutUs, toSettledPlatform, toSubmitUserInfo, toVcModel } from "@/router/components/jumpTo";

export default {
  name: 'PageFootModule',
  components: {
  },
  data() {
    return {
      sellerStatus: 'hide',
      sellerId: '',
      sellerInfos: []
    }
  },
  created() {
  },
  mounted() {
  },
  methods: {
    handleToVcModel() {
      toVcModel()
    },
    handleToSubmitUserInfo() {
      toSubmitUserInfo()
    },
    handleToSettledPlatform() {
      toSettledPlatform()
    },
    handleToAboutUs() {
      toAboutUs()
    },
  }
}
</script>

<style lang="scss" scoped>
$NavItemColor: rgb(255, 255, 255);
$NavItemColorActive: rgb(175, 179, 186);
$ButtonBackColor: #3451e2;
@media screen and (max-width: 768px) {
  .page-foot-box {
    padding: 1.5rem 10vw;

    .page-foot {
      display: flex;
      flex-direction: column;

      .logo-box {
        margin-top: 1rem;
        text-align: left;
        width: 100%;

        .logo {
          font-weight: 700;
          color: $NavItemColor;
        }

        .title {
          margin-top: 2rem;
          font-weight: 700;
          color: $NavItemColor;
          font-size: 1.25rem;
          line-height: 1.75rem;
        }
      }

      .foot-nav-box {
        display: flex;
        flex-direction: row;

        .nav-box {
          flex: 1;
          margin-top: 1rem;
          margin-right: 1.5rem;
          text-align: left;
          font-weight: 700;
        }
      }

      .contact-information-box {
        width: 100%;
        border-radius: 1rem;
        background-color: rgb(24 25 27);
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        .email{
          word-wrap: break-word;
        }
      }


    }
  }

  .email {
    margin: 1rem;
    text-align: left;
  }

  .wx {
    margin: 1rem;
    text-align: left;

    img {
      width: 5.75rem;
      height: 5.75rem;
    }
  }

  .min-title {
    padding-top: .5rem;
    padding-bottom: .5rem;
    font-size: .875rem;
    line-height: 1.25rem;
    color: rgb(119 123 132);
  }

  .nav-title {
    cursor: pointer;
    padding-top: .5rem;
    padding-bottom: .5rem;
    font-size: .875rem;
    line-height: 1.25rem;
    color: rgb(175 179 186);
  }

  .record-number {
    margin-top: 2rem;
    font-size: .75rem;
    color: rgb(119 123 132);
  }
}

@media screen and (min-width: 769px) {
  .page-foot-box {
    padding: 1.5rem 10vw;

    .page-foot {
      display: flex;

      .logo-box {
        margin-top: 1rem;
        text-align: left;
        width: 30rem;

        .logo {
          font-weight: 700;
          color: $NavItemColor;
        }

        .title {
          margin-top: 2rem;
          font-weight: 700;
          color: $NavItemColor;
          font-size: 1.25rem;
          line-height: 1.75rem;
        }
      }

      .foot-nav-box {
        display: flex;
        flex-direction: row;

        .nav-box {
          flex: 1;
          margin-top: 1rem;
          margin-right: 1.5rem;
          text-align: left;
          font-weight: 700;
        }
      }

      .contact-information-box {
        width: 22.3125rem;
        height: 11.5rem;
        border-radius: 1rem;
        background-color: rgb(24 25 27);
        display: flex;
        justify-content: space-between;
      }


    }
  }

  .email {
    margin: 1rem;
    text-align: left;
  }

  .wx {
    margin: 1rem;
    text-align: left;

    img {
      width: 5.75rem;
      height: 5.75rem;
    }
  }

  .min-title {
    padding-top: .5rem;
    padding-bottom: .5rem;
    font-size: .875rem;
    line-height: 1.25rem;
    color: rgb(119 123 132);
  }

  .nav-title {
    cursor: pointer;
    padding-top: .5rem;
    padding-bottom: .5rem;
    font-size: .875rem;
    line-height: 1.25rem;
    color: rgb(175 179 186);
  }

  .record-number {
    margin-top: 2rem;
    font-size: .75rem;
    color: rgb(119 123 132);
  }
}
</style>
